<script lang="ts">
  import { flows, selectedFlow } from '../../../../store'
  import { selectFlow } from '../../../../services'
</script>

{#if $flows.length}
  <div class="flow-select">
    {#each $flows as flow}
      <div 
        class="flow-item" 
        class:active={flow.pk === $selectedFlow.pk}
        on:click={() => selectFlow(flow)}
      >
        {flow.name}
      </div>  
    {/each}
  </div>
{/if}

<style lang="scss">
  .flow-select {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    
    .flow-item {
      border: 2px solid #E0E8F6;
      padding: 6px 55px;
      border-radius: 30px;
      font-size: 14px;
      font-weight: 600;
      line-height: 20px;
      cursor: pointer;
      transition: all .2s;
      white-space: nowrap;
      margin: 4px;

      @media (max-width: 576px) {
        padding: 6px 41px;
        margin-top: 10px;
      }

      &.active {
        background-color: #2B50ED;
        color: white;
        border-color: #2B50ED;
      }
    }
  }
</style>